import { io } from 'socket.io-client';
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {SocketResponse} from "../models/socket-response";
import {ConfigService} from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  socket;
  socketUrl: string;
  observableGetData: Observable<SocketResponse>;

  constructor() {
    this.socketUrl = ConfigService.getAppConfig().socketUrl;
  }

  setupSocketConnection() {
    if(this.socketUrl){
      this.socket = io(this.socketUrl);
      this.observableGetData = new Observable(observer => {
        this.socket.on('get-data', (res: SocketResponse) => {
          observer.next(res);
        });
      });
    }
  }

  socketGetData(){
    return this.observableGetData;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
